import React from 'react';
import { Card, List, Tag, Button, Empty, Typography } from 'antd';
import { TeamOutlined, ClockCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const TurmasDisponiveisList = ({ turmas = [], loading, onSolicitarMatricula }) => {
  const renderHorario = (turma) => {
    if (turma.turma_horario) {
      return turma.turma_horario;
    }
    if (turma.hora_inicio && turma.hora_fim) {
      return `${turma.hora_inicio?.slice(0, 5)} - ${turma.hora_fim?.slice(0, 5)}`;
    }
    return 'Horário a definir';
  };

  return (
    <Card
      title="Turmas Disponíveis"
      bordered={false}
      style={{ marginBottom: 24 }}
    >
      <List
        dataSource={turmas}
        loading={loading}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Nenhuma turma disponível no momento"
            />
          ),
        }}
        renderItem={(turma) => {
          const vagas = typeof turma.vagas_disponiveis === 'number'
            ? turma.vagas_disponiveis
            : Math.max(0, (turma.maximo_alunos || 0) - (turma.total_alunos || 0));
          const temVagas = vagas > 0;

          return (
            <List.Item
              key={turma.id}
              actions={[
                <Button
                  key="solicitar"
                  type="primary"
                  disabled={!temVagas}
                  onClick={() => onSolicitarMatricula?.(turma)}
                >
                  Solicitar matrícula
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Text strong>{turma.nome_turm}</Text>
                    <Text type="secondary">{turma.modalidade_nome}</Text>
                  </div>
                }
                description={
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Text type="secondary">
                      <ClockCircleOutlined style={{ marginRight: 6 }} />
                      {renderHorario(turma)}
                    </Text>
                    {turma.unidade_nome && (
                      <Text type="secondary">
                        <TeamOutlined style={{ marginRight: 6 }} />
                        {turma.unidade_nome}
                      </Text>
                    )}
                  </div>
                }
              />
              <Tag color={temVagas ? 'green' : 'red'}>{vagas} vaga(s)</Tag>
            </List.Item>
          );
        }}
      />
    </Card>
  );
};

export default TurmasDisponiveisList;
